import { useCallback, useLayoutEffect, useState } from 'react';

function useImageStatus(src: string, initialLoad = true) {
  const [loaded, setLoaded] = useState(false);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<any>();

  const load = useCallback(() => {
    if (!src) {
      setError(new Error('invalid src'));
      return;
    }
    setLoading(true);
    const image = new Image();
    image.onload = () => {
      setLoading(false);
      setLoaded(true);
    };
    image.onerror = (err) => {
      setLoading(false);
      setError(err);
    };

    image.src = src;
  }, [src]);

  useLayoutEffect(() => {
    if (initialLoad) {
      load();
    }
  }, [initialLoad, load]);

  return {
    loading,
    error,
    loaded,
    load,
  };
}

export default useImageStatus;
